module.exports = __webpack_public_path__ + "img/security-logos.08c37308.svg";